/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Export_FlagInputs */

const cs_portals_export_flag = /** @type {(inputs: Portals_Export_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na portály`)
};

const en_portals_export_flag = /** @type {(inputs: Portals_Export_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export to portals`)
};

/**
* | output |
* | --- |
* | "Export to portals" |
*
* @param {Portals_Export_FlagInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_export_flag = /** @type {((inputs?: Portals_Export_FlagInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Export_FlagInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_export_flag(inputs)
	return cs_portals_export_flag(inputs)
});